/* eslint-disable eqeqeq */
//Actions
const addToBasket = 'ADD_TO_BASKET'
const increaseItem = 'INCREASE_ITEM'
const reduceItem = 'REDUCE_ITEM'
const removeItem = 'REMOVE_ITEM'
const emptyBasket = 'BASKET_EMPTY'
const getSumBasket = 'GET_SUM_BASKET'

//Reducer
export default function reducer(state = [], action) {
  switch(action.type) {
    case addToBasket : {
      return [ ...state, action.payload ]
    }
    case increaseItem : {
      return state.map(item => {
        if (item._id === action.payload) {
          item.count = item.count + 1
          item.allPrice = item.allPrice + item.price
        }
        return item
      })
    }
    case reduceItem : {
      return state.filter(item => {
        if (item.count >= 1) {
          if (item._id === action.payload) {
            item.count = item.count - 1
            item.allPrice = item.allPrice - item.price
          }
          return item
        }
        return null
      })
    }
    case getSumBasket : {
      return state.map(item => {
        return item
      })
    }
    case removeItem : {
      return state.filter(item => item._id !== action.payload)
    }
    case emptyBasket : {
      return state = []
    }
    default: {
      return state
    }
  }
}

//Action Creators
export const addToBasketAction = (data) => ({
  type: addToBasket,
  payload: {
    _id: data._id,
    name: data.name,
    status: data.status,
    price: parseInt(data.discountPrice) == 0 ? parseInt(data.price) : parseInt(data.discountPrice),
    allPrice: parseInt(data.discountPrice) == 0 ? parseInt(data.price) : parseInt(data.discountPrice),
    count: 1
  }
})

export const increaseItemAction = (id) => ({
  type: increaseItem,
  payload: id
})

export const reduceItemAction = (id) => ({
  type: reduceItem,
  payload: id
})

export const getSumBasketAction = () => ({
  type: getSumBasket
})

export const removeItemAction = (id) => ({
  type: removeItem,
  payload: id
})

export const emptyBasketAction = () => ({
  type: emptyBasket,
})